import DarkModeSwitchSelector from "./DarkModeSwitchSelector";
import DarkModeSwitch from "./DarkModeSwitch";

const { __ } = wp.i18n;
const { Component, Fragment } = wp.element;
const { PanelBody, RangeControl } = wp.components;
const { InspectorControls, BlockControls, AlignmentToolbar } = wp.editor;



class DarkModeSwitchEditor extends Component {
    render() {
        const { attributes, setAttributes } = this.props;

        return (
            <Fragment>
                <InspectorControls>

                    {/* Switch Selector  */}
                    <PanelBody title={__("Switch Style", "wp-dark-mode")}>
                        <DarkModeSwitchSelector
                            value={attributes.style}
                            onChange={(newValue) => {
                                setAttributes({
                                    style: parseInt(newValue),
                                });
                            }}
                        />
                    </PanelBody>

                    {/* Size  */}
                    <PanelBody title={__("Switch Size", "wp-dark-mode")} className="wp-dark-mode-ignore">
                        <RangeControl
                            label="Size"
                            min="0.2"
                            max="5"
                            step="0.1"
                            value={attributes.size}
                            onChange={(size) => {
                                setAttributes({
                                    size: parseFloat(size),
                                });
                            }}
                        />
                    </PanelBody>


                </InspectorControls>

                <BlockControls>
                    <AlignmentToolbar
                        value={attributes.alignment}
                        onChange={(val) => setAttributes({ alignment: val })}
                    />
                </BlockControls>

                <div style={{ textAlign: attributes.alignment }}>
                    <DarkModeSwitch style={attributes.style} size={attributes.size} />
                </div>
            </Fragment>
        );
    }
}

export default DarkModeSwitchEditor;
